import React from 'react';
import PropTypes from 'prop-types';
import FAQRow from 'Components/Rows/FAQRow';

const FAQContent = ({ data }) => {
  return (
    <>
      <div className="page page--faq">
        <div className="faq-container--sub">
          { data?.map((item, index) => (
            <FAQRow
              key={ index }
              question={ item.title }
              answer={ item.content }
              videoOrImages={ item?.videoOrImages }
              faqType="question"
            />
          )) }
        </div>
      </div>
    </>
  );
};

FAQContent.propTypes = {
  data: PropTypes.array,
  hasHeader: PropTypes.bool,
};

export default FAQContent;
